export const type = 'SET_PID_LOADING';

export const setPidLoading = (data) => ({
  data,
  type,
});
